import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Typography } from '@mui/material';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ClientsPage from './pages/ClientsPage'; 
import ProjectsPage from './pages/ProjectsPage';
import TasksPage from './pages/TasksPage'; 
import EmployeesPage from './pages/EmployeesPage'; 
import ExpensePage from './pages/ExpensePage';
import ReceivedPage from './pages/ReceivedPage';
import ProjectDetailView from './pages/ProjectDetailView'; 
import ProtectedRoute, { getHomeRoute } from './components/ProtectedRoute'; // Added getHomeRoute import
import MainLayout from './layouts/MainLayout';
import { AuthProvider, useAuth } from './hooks/UserContext'; // Added useAuth import
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import MyExpensesPage from './pages/MyExpensesPage'; 
import MyTasksPage from './pages/MyTasksPage';
import PettyCashPage from './pages/PettyCashPage';
import PettyCashDetailPage from './pages/PettyCashDetailPage';

// Helper component for the root path
const RootRedirect = () => {
  const { user } = useAuth();
  return <Navigate to={getHomeRoute(user?.role)} replace />;
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Router>
          <Routes>
            <Route path="/login" element={<LoginPage />} />

            <Route element={<ProtectedRoute />}>
              <Route element={<MainLayout />}>
                
                {/* 1. Root Path: Redirects based on role */}
                <Route path="/" element={<RootRedirect />} />

                {/* 2. OWNER, MANAGER */}
                <Route element={<ProtectedRoute allowedRoles={['OWNER', 'MANAGER']} />}>
                  <Route path="/dashboard" element={<DashboardPage />} />
                  <Route path="/employees" element={<EmployeesPage />} />
                  <Route path="/petty-cash" element={<PettyCashPage />} />
                  <Route path="/petty-cash/:userId" element={<PettyCashDetailPage />} />
                </Route>

                {/* 3. OWNER, MANAGER, OFFICE_ADMIN */}
                <Route element={<ProtectedRoute allowedRoles={['OWNER', 'MANAGER', 'OFFICE_ADMIN']} />}>
                  <Route path="/clients" element={<ClientsPage />} />
                  <Route path="/expenses" element={<ExpensePage />} />
                  <Route path="/payments" element={<ReceivedPage />} />
                  <Route path="/projects/:id" element={<ProjectDetailView />} />
                  <Route path="/projects" element={<ProjectsPage />} />
                  <Route path="/tasks" element={<TasksPage />} />                  
                </Route>

                <Route element={<ProtectedRoute allowedRoles={['OWNER', 'MANAGER', 'OFFICE_ADMIN', 'ENGINEER', 'SUPERVISOR', 'TECHNICIAN']} />}>         
                  <Route path="/my-expenses" element={<MyExpensesPage />} />
                </Route>

                {/* 4. ENGINEER, SUPERVISOR, TECHNICIAN */}
                <Route element={<ProtectedRoute allowedRoles={['ENGINEER', 'SUPERVISOR', 'TECHNICIAN']} />}>         
                  
                  <Route path="/my-tasks" element={<MyTasksPage />} />
                  <Route path="/my-expenses" element={<MyExpensesPage />} />
                </Route>

              </Route>
            </Route>

            <Route path="*" element={<Typography variant="h3">404 Not Found</Typography>} />
          </Routes>
        </Router>
      </LocalizationProvider>
    </AuthProvider>
  );
};

export default App;